import React, { RefObject } from "react";
import { PlanDetailsPageSection } from "../../../@types";

interface PlanDetailSectionProps {
  title: string;
  children: React.ReactNode;
  id?: PlanDetailsPageSection | string;
  sectionRef: RefObject<HTMLDivElement>;
  className?: string;
  headingAddOn?: React.ReactNode;
}

const PlanDetailSection: React.FunctionComponent<PlanDetailSectionProps> = ({
  className,
  title,
  children,
  id,
  sectionRef,
  headingAddOn,
}) => {
  return (
    <section
      id={id}
      tabIndex={-1}
      ref={sectionRef}
      className={`PlanDetailsSection ${className ? className : ""}`}
    >
      <div className={`PlanDetailsSection__heading`}>
        <h2>{title}</h2>
        {headingAddOn}
      </div>
      {children}
    </section>
  );
};

export { PlanDetailSection };
